import { storage } from "./storage.js";
import { DEFAULT_API_BASE_URL, normaliseBaseUrl } from "./config.js";

const TOKEN_KEY = "rasmalai.app.token";

export function loadAppSession() {
  const token = storage.get(TOKEN_KEY);
  if (!token) return null;
  return { baseUrl: DEFAULT_API_BASE_URL, token };
}

export function saveAppToken(token) {
  storage.set(TOKEN_KEY, token);
}

export function clearAppToken() {
  storage.remove(TOKEN_KEY);
}

export function apiBase() {
  return normaliseBaseUrl(DEFAULT_API_BASE_URL);
}
